export default {
    auth: {
        title: "Iniciar sesión en NCS",
        logIn: "Iniciar sesión",
        logInAgain: "Iniciar sesión nuevamente",
        logInFailed: "Error al iniciar sesión. Por favor, inténtelo de nuevo.",
        customer: "Cliente",
        customerNotFound: "Cliente no encontrado. Por favor, inténtelo de nuevo.",
        sessionIdle: "Sesión inactiva",
        sessionIdleExplanation: "Su sesión de NCS ha terminado debido a inactividad. Por favor, inicie sesión nuevamente.",
    }
}
